import { Checkbox, Form } from 'antd';
import React, { ReactNode } from 'react';
import './style.css';

/**
 * Props for the CheckBoxCard component.
 */
interface CheckBoxCardProps {
  /** Icon to display next to the checkbox (optional). */
  icon?: ReactNode;
  /** Title text displayed in the card. */
  title?: string;
  /** Whether the checkbox is disabled. */
  disabled?: boolean;
  /** Whether the feature is enabled (checkbox checked state). */
  isFeatureEnabled?: boolean;
  /** Callback function triggered when the checkbox is clicked. */
  onChange?: () => void;
  /** Description text displayed below the title. */
  description?: string;
}

/**
 * A reusable checkbox card component with an optional icon, title, and description.
 *
 * @param {CheckBoxCardProps} props - The component props.
 * @returns {JSX.Element} The rendered CheckBoxCard component.
 */
const CheckBoxCard: React.FC<CheckBoxCardProps> = ({
  icon = <></>,
  title = '',
  isFeatureEnabled = false,
  onChange,
  description = '',
  disabled = false,
}) => {
  /**
   * Handles the click event on the card.
   * Calls the onChange function if the component is not disabled.
   */
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange();
    }
  };
  return (
    <Form.Item style={{ width: '100%', marginBottom: '0px', cursor: disabled ? 'not-allowed' : 'pointer' }}>
      <div
        id="checkBoxCardWrapper"
        className="checkBoxCardWrapper"
        onClick={handleClick}
        style={disabled ? { pointerEvents: 'none', opacity: 0.5 } : {}}
      >
        <div className="checkBoxCardTopView">
          {icon}
          <Checkbox
            style={{ width: '16px !important', height: '16px !important' }}
            checked={isFeatureEnabled}
            disabled={disabled}
          />
        </div>
        <div className="checkBoxCardTitle">{title}</div>
        <div className="checkBoxCardDescription">{description}</div>
      </div>
    </Form.Item>
  );
};

export default CheckBoxCard;
